$(document).ready(function() {


  if( $(".product-media .media-grid").length > 0){
    if ($(window).width() < 992) {
      var $status = $('.pagingInfo');
      var $slickElement = $('.product-media .media-grid');
      $slickElement.on('load init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
       
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.text(i + '/' + slick.slideCount);
      });

      $slickElement.on('afterChange', function(event, slick, currentSlide) {
      document.body.classList.remove('showtext');
    });
      $slickElement.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<span class="slide-arrow prev-arrow"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1172_11712)"><path d="M2.84563 6.00001L8.36112 0.829224L8.89063 1.32704L3.90612 6L8.89063 10.673L8.36113 11.1708L2.84563 6.00001Z" fill="#000300"/></g><defs><clipPath id="clip0_1172_11712"><rect width="11.25" height="12" fill="white" transform="translate(12 0.375) rotate(90)"/></clipPath></defs></svg></span>',
        nextArrow: '<span class="slide-arrow next-arrow"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1172_11707)"><path d="M9.15437 6L3.63888 11.1708L3.10937 10.673L8.09388 6L3.10937 1.32703L3.63887 0.829215L9.15437 6Z" fill="#000300"/></g><defs><clipPath id="clip0_1172_11707"><rect width="11.25" height="12" fill="white" transform="translate(0 11.625) rotate(-90)"/></clipPath></defs></svg></span>',
      });
    }
  }
   var he = $('.media-list').height();
  $(window).on("scroll", function(e) {
    var scroll = $(window).scrollTop();
    if(document.querySelector('.collection:has(.section-collection-banner)')){
      if (scroll >= document.querySelector('.coll-banner-meta').clientHeight) {
        $('#shopify-section-header').addClass('fixed')
        $('body').addClass('fixed_header')
      }else{
        $('#shopify-section-header').removeClass('fixed')
        $('body').removeClass('fixed_header')
      }
    }else{
      if (scroll >= 36) {
        $('#shopify-section-header').addClass('fixed')
        $('body').addClass('fixed_header')
      }else{
        $('#shopify-section-header').removeClass('fixed')
        $('body').removeClass('fixed_header')
      }
    }
    if( $(".main-banner-cls").length > 0){
      var scroll_top = $('.main-banner-cls').offset().top - $(window).scrollTop();
     
      $(".main-banner-cls").each(function() {
        if(scroll_top <= 36){
          $(this).css("padding", "0 24px 30px");
          // $('.media-list').height(he - 60)
        }else{
         $(this).css("padding", "0px");
           // $('.media-list').height(he)
        }
      })
    }
  });
  $(document).on('mouseover','.list-menu li.mega-list',function(e){
    $('body').addClass('overflow').addClass('active_blur').addClass('top_75');
  });
  $(document).on('mouseleave','.list-menu li.mega-list',function(e){
    $('body').removeClass('overflow').removeClass('active_blur').removeClass('top_75');
  });
  $(document).on('click','.header-icons li.search',function(e){
    $('.header-icons li.searchlist').addClass('active');
    $('body').addClass('active_blur active_search');
    $('.snippet-search-bar input#Search').focus();
    $('.snippet-collection-filter').hide();
  });
  $(document).on('click','.snippet-search-bar .search_close',function(e){
    $('.header-icons li.searchlist').removeClass('active');
    $('#Search').val('');
    $('body').removeClass('active_blur active_search')
    $('#predictive-search').hide();
  });
  $(document).on('click','.back_btn',function(e){
    $(this).parents('li').removeClass('active');
  })

  let prevState = '';

  $(document).on('click','.collection_filter_btn span',function(e){
    $('.snippet-collection-filter').slideDown();
    if($(window).width() < 768){
       var scroll = $(window).scrollTop();
      var h ;
      if (scroll >= 36) {
        h = 45;
      }
      else{
        h = 91;
      }
      $('.snippet-collection-filter').css('max-height',( window.visualViewport.height - h));
    }
    $('body').addClass('overflow active_blur top_77')
    $('.header-icons li.searchlist').removeClass('active')
    // Store the current filter state in sessionStorage
    var filterForm = document.querySelector('#form-facet');
    if (filterForm) {
      prevState = new URLSearchParams(new FormData(filterForm)).toString();
    }
  })
  function handleWindowResize() {
  // Get the new window dimensions
    if($(window).width() < 768 && $('.snippet-collection-filter').length > 0 ){
     var scroll = $(window).scrollTop();
     var h ;
    if (scroll >= 36) {
      h = 45;
    }
    else{
      h = 91;
    }
    $('.snippet-collection-filter').css('max-height',( window.visualViewport.height - h));
    }
  }

// Attach the event listener to the window
window.addEventListener('resize', handleWindowResize);
  $(document).on('click','.fillter_btn .apply-filter , .collection .blur_body',function(e){
    $('.snippet-collection-filter').slideUp();
    $('body').removeClass('overflow');
    $('body').removeClass('active_blur')
    $('body').removeClass('top_77');

    var filterForm = document.querySelector('#form-facet');
    var afterState = filterForm ? new URLSearchParams(new FormData(filterForm)).toString() : '';

    if ($(e.target).closest('.apply-filter').length > 0 && prevState !== afterState) {
      setTimeout(function() {
        $(window).scrollTop(0);
      }, 1500);
    }
  })
  // $(document).on('click','.collection .blur_body',function(e){
  //   $('.snippet-collection-filter').hide();
  //   $('body').removeClass('active_blur')
  // })
  if (window.innerWidth > 991) {
   $(document).on('click', '.desk_zoom', function(e) {
    // Show the zoom popup
    $('.zoom_popup').fadeIn(300);
  
    $('body').addClass('overflow');
  });
  }
  
  // $(document).on('click','.desk_zoom , slider_zoom',function(e){
  //   $('.zoom_popup').fadeIn(300);
  //   var imageName,imgoff;
  //     var offsetval = $('.desk_zoom').offset().top - 97;
  //     $('.media-grid.medialist .media-grid-column img').each(function(){
  
      
  //       if(($(this).offset().top + $(this).height()) > offsetval){
  //       if (!(imageName)) {
  //            imgoff = $(this).offset().top - $(window).scrollTop();
  //               imageName = $(this).attr('src');   
  //          }
  //         }
  //     })
//     document.querySelectorAll('.media-grid.medialist .media-grid-column').forEach(function(self){
// console.log('offset',self.querySelector('img').getBoundingClientRect().top + (screen.height/1.5) - 44)
//         if ((self.querySelector('img').getBoundingClientRect().top + (screen.height/2) - 44) > 0) {
//             if (!(imageName)) {
//                 imageName = self.querySelector('img').getAttribute('src');   
//             }
//         }
//     });
  //   document.querySelectorAll('.zoom_popup .media-grid-column').forEach(function(self){
  //       var imageName2 = self.querySelector('img').getAttribute('src');
  //       if (imageName2 == imageName) {
  //           document.querySelector('.zoom_popup ').scrollTo(0, (self.querySelector('img').getBoundingClientRect().top - imgoff));
  //       }
  //   });
  //   $('body').addClass('overflow');
  // })
  $('.close_zoom_popup').click(function(e){
    console.log('click')
    // document.querySelector('.zoom_popup ').scrollTo(0, 0);
    $('.zoom_popup').fadeOut(300);
    $('body').removeClass('overflow');
  })
  document.addEventListener("keydown", function (event) {
  if (event.key === "Escape" || event.key === "Esc") {
    var zoomPopup = document.querySelector(".zoom_popup");
    if (zoomPopup.style.display === "block") {
      // Close the zoom_popup
     // document.querySelector('.zoom_popup ').scrollTo(0, 0);
    $('.zoom_popup').fadeOut(300);
    $('body').removeClass('overflow');;
    }
  }
});

  $(document).on('click','.cart_notification_close',function(e){
    $('.main_cart_notification').removeClass('active');
  })
  $(document).on('click','.add_disc_tab',function(e){
    $(this).closest('.final-total').addClass('active');
    $(this).closest('.drawer-footer').addClass('active');
    $(this).hide();
  })
  $(window).on("scroll", function(e) {
    var scroll = $(window).scrollTop();
      if (scroll >= 100) {
        $('.collection_filter_btn.mobile').addClass('active')
      }else{
        $('.collection_filter_btn.mobile').removeClass('active')
      }
  });
  if ($(window).width() < 768) {
    $(document).on('click','.filter-box .facet-list h4 , .filter-sort h4',function(e){
      $(this).toggleClass('active')
      $(this).next('ul , .range-wrap').slideToggle();
    })     
  }
  $( ".facet-list ul" ).each(function() {
     var li =  $(this).find('li').length
     var dis = $(this).find('.disable-facet').length

    if(li == dis){
      $(this).closest('.facet-list').addClass('hide_main')
    }else{
      $(this).closest('.facet-list').removeClass('hide_main')
    }
  });

  var mega_top_height = $('.menu_drawer_top').height()
  $("ul.navmobile-dropdown").css("padding-top", mega_top_height + 'px'); 

  // var device_height = $(window).height() - 33;
  // $(".media-list").each(function() {
  //     $(this).css("height", device_height + 'px');
  // });

  $(document).on('click','.blur_body',function(e){
    $('.header-icons li.searchlist').removeClass('active');
    $('body').removeClass('active_blur active_search');
    $('#predictive-search').hide();
    $('body').removeClass('open-drawer');
  })
  $(document).on('click','#cart-notification-button',function(e){
      if($(window).width() < 768){
        $('body').attr( 'data-pos', $(window).scrollTop()); // get actual scrollpos
         $('body').scrollTop( $('body').attr( 'data-pos' ) ); 
        $('body').addClass('locked'); // add class to body
      }
    $('body').addClass('open-drawer');
      $('.shiping_info .list').infiniteslide({
        'speed': 100,
        'direction': 'left',
        'pauseonhover': true,
        'responsive': false,
        'clone': 2
      });
  })


if($('.section-announcement-bar ul').length > 0){
if ($(window).width() < 768) {
$('.section-announcement-bar ul').infiniteslide({
  'speed': $('.section-announcement-bar ul').data('speed'),
  'direction': 'left',
  'pauseonhover': true,
  'responsive': false,
  'clone': 1
});
}
}

$('.var_label .size-chart').click(function(){
   $('body').addClass('active_blur');
   $('body').addClass('open_size_chart'); 
});
$('.size-drawer-close').click(function(){
    $('body').removeClass('active_blur');
   $('body').removeClass('open_size_chart'); 
});
  
$('.blur_body').click(function(){
  console.log('click')
  $('body').removeClass('active_blur');
   $('body').removeClass('open_size_chart');
})  
  
});






if (window.innerWidth < 992) {

  $(document).on('click', '.media-grid .media-grid-column', function () {
    const clickedImgSrc = $(this).find('img').attr('src');
    $('body').data('clicked-img-src', clickedImgSrc);
    $('.desk_zoom').trigger('click');
  });
  $(document).on('click', '.desk_zoom', function () {
    // Get the src of the slick-active image
    const clickedImgSrc = $('.media-grid .media-grid-column.slick-active').find('img').attr('src');
    $('body').data('clicked-img-src', clickedImgSrc);
  
    // Show the popup
    $('.zoom_popup').fadeIn(300);
    $('body').addClass('overflow');
  
    // Scroll to the corresponding image inside the zoom popup
    const targetSrc = clickedImgSrc;
    setTimeout(function () {
      let found = false;
      document.querySelectorAll('.zoom_popup .media-grid-column img').forEach(function (img) {
        if (!found && img.getAttribute('src') === targetSrc) {
          const scrollTop = img.offsetTop;
          document.querySelector('.zoom_popup').scrollTo(0, scrollTop);
          found = true;
        }
      });
    }, 50);
  });
}





